import React from "react";
import { useLocation } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

interface RecaptchaProviderProps {
  children: React.ReactNode;
}

const RecaptchaProvider: React.FC<RecaptchaProviderProps> = ({ children }) => {
  const location = useLocation();
  const isAuthPage =
    location.pathname === "/login" || location.pathname === "/register";
  const recaptchaKey =
    process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY ||
    "6LciijssAAAAAPi2UR7idpiyUPU3UGVOK5xBMQbj";

  // Only render reCAPTCHA provider on login and register pages
  if (isAuthPage && recaptchaKey) {
    return (
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaKey}
        scriptProps={{ async: true, defer: true }}
      >
        {children}
      </GoogleReCaptchaProvider>
    );
  }

  // For other pages, render children without reCAPTCHA provider
  return <>{children}</>;
};

export default RecaptchaProvider;
